<template>
  <div id="Turnover">
    <loading v-if="loadingRender"></loading>
    <panel v-if="wwwtblSarfaslTypeId == 1 && !$cookies.get('IsAnbohSaz')==false" Title="گردش تسهیلات" Des="از طریق این فرم می توانید گردش تسهیلات خود را در بازه زمانی دلخواه خود مشاهده کنید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <panel v-else-if="wwwtblSarfaslTypeId == 2 || wwwtblSarfaslTypeId == 6 || wwwtblSarfaslTypeId == 13 && !$cookies.get('IsAnbohSaz')==false" Title="گردش حساب ها" Des="از طریق این فرم می توانید گردش حساب های خود را در بازه زمانی دلخواه خود مشاهده کنید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <panel v-else Title="صورت حساب" Des="از طریق این فرم می توانید گردش حساب های خود را در بازه زمانی دلخواه خود مشاهده کنید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row">
      <div class="card p-3 m-3 w-100" id="Date">
        <div class="row">
          <div class="co-md-3 col-12">
            <i class="fa fa-reply Pointer border border-warning rounded-circle p-1" title="بازگشت صفحه قبل" @click="$router.go(-1)"></i>
          </div>
        </div>
        <div class="row">
          <span class="alert alert-dark w-100 p-2 m-2 text-center">لطفا بازه زمانی خودرا انتخاب کرده و سپس گزینه <span class="text-success">جستجو</span> را بزنید </span>
        </div>
        <div class="row">
          <div class="col-md-4 col-12 mt-2 text-right">
            <small>انتخاب حساب</small>
            <select v-if="IsLoad" name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer" v-model="Resultcmb">
              <option v-if="this.IsLoad == false" value="-2">|| در حال بارگذاری ، منتظر بمانید ... ||</option>
              <option selected value="-1">-- انتخاب حساب --</option>
              <option v-for="item in this.ListModel" :key="item.id" :value="item.id">
                <span>{{ item.vcodeDesNo }}</span>
                <span>{{ item.nameFamily }} </span>
              </option>
            </select>
          </div>
          <div class="col-md-2 col-12 mt-2 text-right">
            <small>تاریخ از </small>
            <date-picker :editable="true" :auto-submit="true" :max="TarikhTa" color="rgb(94 163 30)" v-model="TarikhAz" :disabled="Dahgardesh"> </date-picker>
            <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
          </div>
          <div class="col-md-2 col-12 mt-2 text-right">
            <small>تاریخ تا</small>
            <date-picker :editable="true" :auto-submit="true" :min="TarikhAz" color="rgb(94 163 30)" v-model="TarikhTa" :disabled="Dahgardesh"> </date-picker>
            <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
          </div>
          <div class="col-md-2 col-12 mt-4">
            <span class="form-control p-1">
              <div class="custom-control custom-switch text-right">
                <input type="checkbox" class="custom-control-input InputText" id="gardesh" :checked="Dahgardesh" @change="DahgardeshChange()" :v-model="Dahgardesh" />
                <label class="custom-control-label p-1" for="gardesh">ده گردش آخر</label>
              </div>
            </span>
          </div>
          <div class="col-md-2 col-12 mt-3">
            <input
              type="button"
              name=""
              value="جستجو"
              class="btn btn-success mt-2 w-100"
              @click="
                GetGardesh()
                $ResetTimer()
              "
            />
          </div>
          <div class="col-md-2 col-12 mt-3">
            <export-excel :data="exceltable">
              <button class="btn btn-outline-success d-none">
                <i class="fas fa-file-excel btn btn-outline-success Pointer d-none" id="DownloadExcel"> دانلود فایل اکسل </i>
              </button>
            </export-excel>
          </div>
        </div>
      </div>
    </div>

    <vue-bootstrap4-table  v-if="Istable" :rows="rows" :columns="columns" :config="config" :classes="classes" :actions="actions" @on-download="Download" @on-chart="DrawChart" @on-download-pdf="GetPDF">
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="empty-results">
        <p class="text-right">اطلاعاتی یافت نشد</p>
      </template>
      <template slot="sharh" slot-scope="props">
        <i class="fas fa-credit-card text-warning px-2" style="font-size: 16px" v-if="props.cell_value != ''"></i>
        {{ props.cell_value }}
      </template>
      <template slot="reciept" slot-scope="props">
        <a @click="Recipt(props.row)" class="Pointer"> <i class="fas fa-download text-secondary"></i></a>
        {{ props.cell_value }}
      </template>
      <template slot="amaliyat" slot-scope="props">
        <div v-if="wwwtblSarfaslTypeId == 1">
          <small v-if="props.cell_value == 'دريافت تسهيلات'" class="text-danger">
            <i class="fa fa-arrow-up"></i>
            {{ props.cell_value }}
          </small>
          <small v-else class="text-success">
            <i class="fa fa-arrow-down"></i>
            {{ props.cell_value }}
          </small>
        </div>
        <div v-else>
          <small v-if="props.cell_value == 'برداشت'" class="text-danger">
            <i class="fa fa-arrow-up"></i>
            {{ props.cell_value }}
          </small>
          <small v-else class="text-success">
            <i class="fa fa-arrow-down"></i>
            {{ props.cell_value }}
          </small>
        </div>
      </template>
      <template slot="Action" slot-scope="props">
        <button @click="RemoveBedeh(props.row)" v-if="props.row.bedeh.replace(/,/g, '').replace(/\./g, '') > 0 && (props.row.bnpCashDBtblSanadRizId == 0 || props.row.bnpCashDBtblSanadRizId == null)" class="btn btn-danger"><i class="fas fa-trash ml-2"></i> حذف درخواست برداشت</button>
        <span v-else>تراکنش ثبت سند شده است</span>
      </template>
    </vue-bootstrap4-table>
    <div v-else dir="ltr">
      <button @click="DrawChart" class="btn btn-outline-success">
        <i class="fas fa-table"></i>
      </button>
      <apexchart type="area" height="350" :options="chartOptions" :series="series"></apexchart>
    </div>
  </div>
</template>
<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import Panel from '../Tools/NetPa/Panel.vue'
import loading from '../Tools/NetPa/Loading.vue'
import html2pdf from 'html2pdf.js'


export default {
  data() {
    return {
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Gardesh_Taahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      ListModel: null,
      ListModelSahebHesab: null,
      IsLoad: false,
      TarikhAz: '',
      TarikhTa: '',
      exceltable: [],
      Resultcmb: null,
      Istable: true,
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },

        {
          label: 'شرح سند',
          name: 'sharh',
          column_classes: 'sharhSand',
          row_classes: 'sharhSand',
          visibility: this.$session.get('CustCode') == 868 ? false : true,
        },
        {
          label: 'تاریخ تراکنش',
          name: 'tarix',
          sort: true, // "false" by default
          initial_sort: true, // "false" by default
          initial_sort_order: 'desc',
        },
        {
          label: 'تراکنش',
          name: 'amaliyat',
        },
        {
          label: 'واریز',
          name: 'bestan',
        },
        {
          label: 'برداشت',
          name: 'bedeh',
        },
        {
          label: 'مانده',
          name: 'mande',
        },
        {
          label: 'رسید',
          name: 'reciept',
        },
        // {
        //   label: 'عملیات',
        //   name: 'Action',
        // },
      ],
      actions: [
        {
          btn_text: 'Pdf',
          event_name: 'on-download-pdf',
          class: 'btn btn-secondary rounded btnEXL ',
          event_payload: {
            msg: 'my custom msg',
          },
        },
        {
          btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
          event_name: 'on-download',
          class: 'btn  mx-2 btn-outline-success rounded btnEXL ',
          event_payload: {
            msg: 'my custom msg',
          },
        },
        {
          btn_text: "<i style='font-size:15px' class='fas fa-chart-line '>",
          event_name: 'on-chart',
          class: 'btn  btn-outline-danger rounded  ',
          event_payload: {
            msg: 'my custom msg',
          },
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page: 100,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      series: [
        {
          name: '',
          data: [],
        },
        {
          name: '',
          data: [],
        },
        {
          name: '',
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'area',

          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: 'smooth',
          },
          toolbar: {
            autoSelected: 'zoom',
          },
        },
        dataLabels: {
          enabled: false,
        },

        title: {
          text: '',
          align: '',
        },
        colors: ['#2A3F54', '#435ebe', '#ff5000'],
        yaxis: {
          title: {
            text: 'موجودی',
          },
        },
        xaxis: {
          type: 'string',
          categories: [],
        },
        tooltip: {
          shared: false,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40,
        },

        markers: {
          size: 1,
        },
      },
      loadingRender: false,
      Dahgardesh: false,
    }
  },
  mounted() {
    this.$AutoCloseMenuForMobile()

    const formData = new FormData()
    let info
    formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
    formData.append('wwwtblSarfaslTypeId', this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId)
    this.DataAxios_cmbTaahodat.ArryfildValue = formData
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true
        this.ListModel = data
        this.Resultcmb = this.TaahodatId == undefined ? data[0].id : this.TaahodatId
      })
      .finally(() => {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId)
        this.DataAxios_SahebHesab.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true
            this.ListModelSahebHesab = data
            for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
              info = this.ListModelSahebHesab[index]
              this.ListModel.push(info)
            }
          }
        })
      })
  },
  components: {
    VueBootstrap4Table,
    Panel,
    loading,
  },

  methods: {
    RemoveBedeh(row) {
      this.$mySweetDefaultTost('درحال بررسی', 'درحال بررسی حذف درخواست برداشت از حساب ، لطفا منتظر بمانید', 'info')
      var DataAxios_Data = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Gardesh_Taahodat/RemoveBardasht',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtblGardeshId', row.id)
      formData.append('Mablagh', row.bedeh.replace(/,/g, ''))
      formData.append('wwwtblEnteghal', row.wwwtblEnteghalId)
      DataAxios_Data.ArryfildValue = formData

      this.$PostFormData(DataAxios_Data).then((data) => {
        if (data.status == 'Ok') {
          this.$mySweetDefaultTost('حذف موفق', ' حذف درخواست برداشت از حساب مورد نظر با موفقیت انجام شد', 'success', 4000)
          this.GetGardesh()
        }
      })
    },
    DahgardeshChange() {
      if (this.Dahgardesh) {
        this.Dahgardesh = false
      } else {
        this.Dahgardesh = true
        this.TarikhAz = ''
        this.TarikhTa = ''
      }
    },
    Recipt(data) {
      this.loadingRender = true
      var DataAxios_Data = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Gardesh_Taahodat/GardeshDetail',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtblEnteghalId', data.wwwtblEnteghalId)
      DataAxios_Data.ArryfildValue = formData

      this.$PostFormData(DataAxios_Data)
        .then((res) => {
          this.loadingRender = false
          if (res.status == true) {
            if (res.data.length == 2) {
              var htmls = `
              <div class=" container-f textblack p-4" dir="rtl">
                <div class="containerbackground ">رسید عملیات مالی </div>
                <div class="row">
                  <div class="col-3"></div>
                  <div class="col-6 text-center">
                    <h4>رسید تراکنش </h4>
                    <h6>${this.$session.get('NameSandogh')}</h6>
                  </div>
                  <div class="col-3 text-center" >
                  </div>
                </div>
                <div class="row textblack">
                  <div class="col-12 text-right">
                    <p>تاریخ صدور:${this.$GetJalaliDate()}</p>
                  </div>
                </div>
              </div>
              <div class="row textblack border p-3 mt-2 mx-4">
                <div class="container">
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">نوع عملیات:</div>
                    <div class="col-6 text-right text-info">
                      ${res.data[0].wwwTaahodatId > 0 && res.data[1].wwwTaahodatId > 0 ? 'انتقال وجه داخلی' : 'انتقال وجه'}
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مبدا</div>
                    <div class="col-6 ">
                      ${res.data[0].fullname}  <span dir="ltr" class="float-right"> ${res.data[0].vCode}</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مقصد</div>
                    <div class="col-6">
                       ${res.data[1].fullname}  <span dir="ltr" class="float-right"> ${res.data[1].vCode}</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مبلغ:</div>
                    <div class="col-6 text-right">
                      ${data['mablagh']}  ${this.$cookies.get('VahedPool')}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">تاریخ تراکنش:</div>
                    <div class="col-6 text-right">
                      ${data['tarix']}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">ساعت تراکنش:</div>
                    <div class="col-6 text-right">
                      ${res.data[0].zamanInsert}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">شرح وضعیت:</div>
                    <div class="col-6 text-right">
                      ${data['sharh']}

                    </div>
                  </div>
                </div>
              </div>
                  <div class="row">
                  <div class="col-12 text-center textblack">
                      <hr>
                      <span style="font-size: x-small;">
                          طراحی و پیاده سازی شرکت پاسارگاد
                      </span>
                      </br>
                      <img style="height:10% !important" src="/img/icons/apple-touch-icon-180x180.png">
                      </br>
                      <span style="font-size: x-small;">
                          www.bnpco.ir
                      </span>

              </div>
              </div>`
            }
            if (res.data.length == 1) {
              var htmls = `
              <div class=" container-f textblack p-4" dir="rtl">
                <div class="containerbackground ">رسید عملیات مالی </div>
                <div class="row">
                  <div class="col-3"></div>
                  <div class="col-6 text-center">
                    <h4>رسید تراکنش </h4>
                    <h6>${this.$session.get('NameSandogh')}</h6>
                  </div>
                  <div class="col-3 text-center" >
                  </div>
                </div>
                <div class="row textblack mt-2">
                  <div class="col-12 text-right">
                    <p>تاریخ صدور:${this.$GetJalaliDate()}</p>
                  </div>
                </div>
              </div>
              <div class="row textblack border p-3 mx-4">
                <div class="container">
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">نوع عملیات:</div>
                    <div class="col-6 text-right ${data.amaliyat == 'برداشت' ? 'text-danger' : 'text-success'}">
                      ${data.amaliyat}
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مبدا</div>
                    <div class="col-6 ">
                      ${data.amaliyat == 'برداشت' ? res.data[0].fullname : ''}  <span dir="ltr" class="float-right"> ${data.amaliyat == 'برداشت' ? res.data[0].vCode : '-'}</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مقصد</div>
                    <div class="col-6">
                         <span dir="ltr" class="float-right"> ${
                           data.amaliyat == 'برداشت' ? (res.data[0].cardNo == null ? res.data[0].shebaNo + ' : شبا ' + ' ' + res.data[0].sahebHesab : res.data[0].cardNo.match(/.{1,4}/g).join('-') + ' : کارت ' + ' ' + res.data[0].sahebHesab) : res.data[0].vCode + ' - ' + res.data[0].fullname
                         }</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مبلغ:</div>
                    <div class="col-6 text-right">
                      ${data['mablagh']}  ${this.$cookies.get('VahedPool')}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">تاریخ تراکنش:</div>
                    <div class="col-6 text-right">
                      ${data['tarix']}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">ساعت تراکنش:</div>
                    <div class="col-6 text-right">
                      ${res.data[0].zamanInsert}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">شرح وضعیت:</div>
                    <div class="col-6 text-right">
                      ${data['sharh']}

                    </div>
                  </div>
                </div>
              </div>
                  <div class="row">
                  <div class="col-12 text-center textblack">
                      <hr>
                      <span style="font-size: x-small;">
                          طراحی و پیاده سازی شرکت پاسارگاد
                      </span>
                      </br>
                      <img style="height:10% !important" src="/img/icons/apple-touch-icon-180x180.png">
                      </br>
                      <span style="font-size: x-small;">
                          www.bnpco.ir
                      </span>

              </div>
              </div>`
            }
            var htmlObject = document.createElement('div')
            htmlObject.innerHTML = htmls
            html2pdf(htmlObject, {
              jsPDF: { format: 'a5' },
            })
          }
          else{
          //this.$mySweetDefaultTost('خطا', res.message, 'warning', 4000)

      var htmls = `
    <div class=" container-f textblack p-4" dir="rtl">
      <div class="containerbackground ">رسید عملیات مالی </div>
      <div class="row">
        <div class="col-3"></div>
        <div class="col-6 text-center">
          <h4>رسید تراکنش </h4>
          <h6>${this.$session.get('NameSandogh')}</h6>
        </div>
        <div class="col-3 text-center" >
        </div>
      </div>
      <div class="row textblack">
        <div class="col-12 text-right">
          <p>تاریخ صدور:${this.$GetJalaliDate()}</p>

        </div>

      </div>
    </div>
    <div class="row textblack border p-3 mt-2 mx-4">
      <div class="container">
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">نوع عملیات:</div>
          <div class="col-6 text-right">
             ${data['amaliyat']}
          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">مشخصات حساب</div>
          <div class="col-6 text-right">
             ${data['desNoe']} -- <span dir="ltr"> ${data['vCode']}</span>

          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">مبلغ:</div>
          <div class="col-6 text-right">
             ${data['mablagh']}  ${this.$cookies.get('VahedPool')}

          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">تاریخ تراکنش:</div>
          <div class="col-6 text-right">
             ${data['tarix']}

          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">شرح وضعیت:</div>
          <div class="col-6 text-right">
             ${data['sharh']}

          </div>
        </div>
      </div>
    </div>
        <div class="row">
        <div class="col-12 text-center textblack">
            <hr>
            <span style="font-size: x-small;">
                طراحی و پیاده سازی شرکت پاسارگاد
            </span>
            </br>
            <img style="height:10% !important" src="/img/icons/apple-touch-icon-180x180.png">
            </br>
            <span style="font-size: x-small;">
                www.bnpco.ir
            </span>

    </div>
    </div>`

      var htmlObject = document.createElement('div')
      htmlObject.innerHTML = htmls
      html2pdf(htmlObject, {
        jsPDF: { format: 'a5' },
      })
          }
        })
        .catch(function (err) {
          console.error(err)
        })

      // <img style="max-width:100% !important" src="${this.$cookies.get('URL') + 'PDF/logo.png'}" alt="${this.$session.get('NameSandogh')}">
    },
    Download() {
      document.getElementById('DownloadExcel').click()
    },
    exelReport(rows) {
      // console.log('Reeeeeeeeport', rows);
      this.exceltable = []
      rows.forEach((element) => {
        var excelrow = {
          'شماره حساب': element.vCode,
          'شرح سند': element.sharh,
          تراکنش: element.amaliyat,
          واریز: element.bestan,
          برداشت: element.bedeh,
          موجودی: element.mande,
          تاریخ: element.tarix,
        }

        this.exceltable.push(excelrow)
      })
      // console.log( this.exceltable);
    },
    GetGardesh() {
      if (this.Resultcmb == null || this.Resultcmb == -1) {
        this.$mySweetDefaultTost('خطا', 'لطفا یک حساب انتخاب کنید', 'warning', 2000)
        this.rows = []
      } else {
        this.loadingRender = true
        const formData = new FormData()
        formData.append('wwwtblTaahodatId', this.Resultcmb)
        formData.append('AzTarix', this.TarikhAz == null ? '' : this.TarikhAz)
        formData.append('TaTarix', this.TarikhTa == null ? '' : this.TarikhTa)
        formData.append('TerminalIdInput', '')
        this.DataAxiosRow.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRow).then((data) => {
          if (data.length) {
            let info
            let list = []
            if (this.Dahgardesh == true && data.length > 10) {
              list = []
              for (let index = 0; index < 10; index++) {
                info = data[index]
                list.push(info)
              }
            } else {
              list = []
              if (data.length > 10) {
                this.config.pagination = true
              } else {
                this.config.pagination = false
              }
              for (let index = 0; index < data.length; index++) {
                info = data[index]
                list.push(info)
              }
            }
            this.rows = this.$FormatMablaghGrid(list)
            this.exelReport(this.rows)

            this.series = [
              {
                name: '',
                data: [],
              },
              {
                name: '',
                data: [],
              },
              {
                name: '',
                data: [],
              },
            ]

            for (let index = list.length - 1; index >= 0; index--) {
              const element = data[index]
              this.chartOptions.xaxis.categories.push(element.tarix)
              this.series[0].name = 'مانده'
              this.series[0].data.push(Number(element.mande.replace(/,/g, '')))
              this.series[1].name = 'واریز'
              this.series[1].data.push(Number(element.bestan.replace(/,/g, '')))
              this.series[2].name = 'برداشت'
              this.series[2].data.push(Number(element.bedeh.replace(/,/g, '')))
            }
            // console.log('series',this.series);
            this.loadingRender = false
          } else {
            this.$mySweetDefaultTost('عدم وجود اطلاعات', 'تراکنشی یافت نشد ، فیلتر جستجوی خود را تغییر دهید', 'warning', 2000)
            this.config.pagination = false
            this.rows = []
            this.loadingRender = false
          }
        })
      }
    },
    DrawChart() {
      this.Istable = !this.Istable
    },
    GetPDF() {
      if (this.rows.length>0) {
        this.$router.push({name:'TurnoverPDF',params:{Rows:this.rows,Taahod:find}})
      }
    },
  },
  props: ['TaahodatId', 'wwwtblSarfaslTypeId', 'wwwtblAzaId', 'wwwtblAzaIdAccount'],
  created() {
    if (this.wwwtblAzaId) {
      this.$session.set('UserFromLoan', [this.wwwtblAzaId, false])
    }
    if (this.wwwtblAzaIdAccount) {
      this.$session.set('UserFromAccount', [this.wwwtblAzaIdAccount, false])
    }
  },
}
</script>
<style>
.sharhSand {
  text-align: right !important;
}

.btn-group {
  float: left !important;
}
.container-f {
  position: relative !important;
}

.containerbackground {
  margin: 3rem;
  position: absolute;
  top: 200px;
  left: 100px;
  z-index: -1;
  transform: rotate(-20deg);
  -webkit-transform: rotate(-20deg);
  color: #abe4f871;
  font-size: 40px;
}
.textblack {
  color: rgb(70, 70, 70) !important;
  border-color: rgb(70, 70, 70) !important;
  border-radius: 10px !important;
  padding: 2% !important;
}
</style>
